module.exports = __webpack_public_path__ + "img/overview_build6.2c0ada23.png";